var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tarja-container",style:(_vm.containerPosition)},[_c('Wrapper',{staticClass:"tarja-svg"}),_c('div',{staticClass:"header-text"},[_vm._v("INSCRITOS")]),_c('div',{staticClass:"description-text"},[_vm._v(" "+_vm._s(_vm.animatedCount)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }